import { connect } from 'react-redux';

import PersonCardItem from './PersonCardItem';

const mapStateToProps = state => ({
  config: state.configurations,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PersonCardItem);
